import { defineNuxtPlugin } from '@nuxtjs/composition-api';

import { useSentry } from '@/plugins/sentry';

export default defineNuxtPlugin(async () => {
  if (process.server) {
    return;
  }

  const sentry = useSentry();

  try {
    // 1. Удаляем все Service Workers
    if ('serviceWorker' in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      for (const registration of registrations) {
        await registration.unregister();
        console.log('[SW] unregistered:', registration);
      }
    }

    // 2. Чистим Cache Storage (то, что создаёт SW)
    if ('caches' in window) {
      const cacheNames = await caches.keys();
      await Promise.all(
        cacheNames.map((cacheName) => {
          console.log('[SW] deleting cache:', cacheName);
          return caches.delete(cacheName);
        }),
      );
    }
  } catch (error) {
    console.error('[SW] cleanup error:', error);
    sentry.captureException(error);
  }
});
